/**
 * Marking an answer as wrong, and taking the mark back (Phase 5, 2026-09-26;
 * `document-ai/0030` §2.7.6, the default of the design's Q6).
 *
 * Its own file rather than a hook in `chat-api.ts`, which another slice owns
 * while Phase 5 is built in parallel.
 */
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api, errorMessage } from "@/api/client";
import { chatKeys } from "./chat-api";

export function useMarkWrong(projectId: string, threadId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (input: { messageId: string; wrong: boolean }): Promise<boolean> => {
      const res = await api.chat.markWrong({
        params: { id: projectId, threadId, messageId: input.messageId },
        body: { wrong: input.wrong },
      });
      if (res.status !== 200) throw new Error(errorMessage(res));
      return res.body.markedWrong;
    },
    // `onSettled`: after a failure too, the stored thread is the truth, and
    // the mark on screen is read back from it.
    onSettled: () => {
      void queryClient.invalidateQueries({ queryKey: chatKeys.thread(projectId, threadId) });
    },
  });
}
